import { WATCHFACE_COLOR_GROUP } from '..';
import { uidColorGroupToZero, uint32 } from '../../utils';
import { totalThemeRecordCount } from '../constant';
import { IMG, IMG_ARRAY } from '../dataSource';

export const FILE_DATA_PRE_LENGTH = 20;
export const SLOT_PRE_LENGTH = 4;
export const WIDGET_PRE_LENGTH = 44;

/**
 * 生成record uid
 * @param recordType record类型
 * @param isRecordAdd 记录是否增加，对于多配色中的同一组图片或同一组图组，不增加record个数
 * @param colorGroup 配色组的键值
 * @param recordColorCount 如果isRecordAdd为false，需要当前record的个数
 * @returns
 */
export function genId(
  recordType: number,
  isRecordAdd = true,
  colorGroup?: string,
  recordColorCount?: number
) {
  let index = 0;
  if (colorGroup && (recordType === IMG || recordType === IMG_ARRAY)) {
    index = WATCHFACE_COLOR_GROUP.indexOf(colorGroup);
  }
  const uid = uint32(
    (recordType << 24) +
      (index << 19) +
      (recordColorCount !== undefined
        ? recordColorCount
        : totalThemeRecordCount[recordType])
  );
  isRecordAdd && totalThemeRecordCount[recordType]++;
  return uid;
}

export function genRecord(
  type: number,
  name: string,
  uid: Buffer,
  dataAddress: number,
  dataLength: number,
  colorGroup?: string
) {
  let originRecord = {
    type,
    name,
    uid,
    dataAddress,
    dataLength
  };
  if (colorGroup) originRecord = Object.assign(originRecord, { colorGroup });
  return originRecord;
}

export function getRelateRecordUid(
  relateRef: string,
  recordsList: any[],
  type?: number
): Buffer | 0 {
  if (!relateRef) return 0;
  let relateImgArrayRecordUid: Buffer = Buffer.alloc(4);
  const relateRecord = recordsList.find((record) => {
    return (
      record.name ===
        (relateRef.startsWith('@') ? relateRef.slice(1) : relateRef) &&
      (record.type === type || !type)
    );
  });
  if (relateRecord) {
    const { uid: relateUid, colorGroup } = relateRecord;
    if (colorGroup) {
      relateImgArrayRecordUid = uidColorGroupToZero(relateUid);
    } else relateImgArrayRecordUid = relateUid;
    return relateImgArrayRecordUid;
  } else return 0;
}

export function makeFillUpOfFour(str: string) {
  const len = str.length;
  if (len % 4 === 0) {
    return { fillUpstr: str, fillUpLength: len };
  } else {
    const nextMultipleOfFour = Math.ceil(len / 4) * 4;
    const paddingLength = nextMultipleOfFour - len;
    const paddingBuffer = Buffer.alloc(paddingLength, 0x00);
    const paddingString = paddingBuffer.toString();
    return { fillUpstr: str + paddingString, fillUpLength: nextMultipleOfFour };
  }
}
